/* VOROG — LE SON, TROISIÈME GÉNÉRATION : LA BANQUE.

   ALLUMÉ D'ORIGINE AU TIERS, décision du patron, et IL S'ALLUME AU
   DÉFILEMENT — pas au clic sur le bouton. Sur téléphone, faire défiler
   suffit vraiment (un défilement se termine par un `touchend`, que le
   navigateur accepte comme activation) ; sur ordinateur à la molette, il
   faut encore un clic ou une touche quelque part, et ça ne dépend pas de
   nous. Celui qui coupe est respecté pour toujours (localStorage). Le
   bouton de l'en-tête reste le seul interrupteur.

   LES DEUX PREMIÈRES GÉNÉRATIONS ÉTAIENT SYNTHÉTISÉES — un motif d'arcade,
   puis des nappes d'atelier. Le verdict est tombé deux fois : ça sonnait
   fabriqué. Celle-ci joue de VRAIS sons : un beat sombre en fond, et des
   gestes enregistrés — verrou métallique, tranche de papier, souffle grave.

   PAS UN OCTET NE PART TANT QUE C'EST ÉTEINT. La musique (3,3 Mo) et les
   effets (quelques dizaines de Ko chacun) ne sont téléchargés qu'au premier
   allumage, à la demande, puis gardés en mémoire décodée. Le visiteur qui ne
   touche pas au bouton paie zéro réseau et zéro contexte audio.

   LA PALETTE — les mêmes dix gestes, les noms n'ont pas bougé :
     tap       la pression sèche d'un interrupteur — liens, boutons
     effleure  le grain d'un survol, trois fois plus discret
     cran      le tic d'horlogerie d'un cran de roulette
     lame      le verrou métallique : la marque est forgée, ça se scelle
     panier    un verrou rapide : quelque chose est pris
     ouvre     une feuille déplacée : le popup se présente
     succes    trois notes douces : l'affaire est faite
     souffle   le souffle grave sous la coulée d'encre
     trait     la lame qui tranche le papier : le titre s'écrit
     page      une feuille qu'on tire : la navigation part

   La musique respire SOUS les gestes (0,32 contre 0,4-0,85), le compresseur
   rattrape les rencontres, et deux sons ne partent jamais à moins de 45 ms
   l'un de l'autre : le son accompagne le geste, il ne le commente pas.

   L'ENTRÉE DU THÈME EST UN COUP, PAS UNE ARRIVÉE. Le morceau tombe à 0,55
   pendant sept secondes — le temps de sa mesure d'ouverture — puis redescend
   tout seul à sa vitesse de croisière. C'est le drop qui doit s'entendre,
   pas la boucle.

   ET IL SE TAIT QUAND PERSONNE N'ÉCOUTE. Onglet caché, fenêtre passée
   derrière, ou plus un geste depuis une minute : tout s'endort en un fondu
   d'un quart de seconde et le contexte audio se suspend. Le moindre
   mouvement le réveille, et le morceau repart où il en était. Un site qui
   continue de jouer dans un onglet oublié, c'est le genre de chose qu'on
   ferme pour de bon. */
(function () {
  var CLE = 'vorog-son', CLEV = 'vorog-son-vol';
  var CFG = window.VOROG_AUDIO || null;
  var ctx = null, maitre = null;
  /* ALLUMÉ D'ORIGINE, AU TIERS — décision du patron, qui renverse le réglage
     prudent d'avant. Le navigateur, lui, ne change pas d'avis : rien ne peut
     sonner avant le premier geste (clic, touche, défilement). Le visiteur qui
     coupe garde son choix pour toujours via localStorage ; celui qui n'a
     jamais touché au bouton arrive donc allumé, à 33/100. */
  var actif = true;
  var volume = 33;
  try {
    var sv = localStorage.getItem(CLE);
    if (sv !== null) actif = sv === '1';
    var v = parseInt(localStorage.getItem(CLEV), 10);
    if (v >= 0 && v <= 100) volume = v;
  } catch (e) {}

  // Courbe perceptive : la moitié du curseur doit s'entendre comme la moitié
  // du volume, pas comme les trois quarts.
  function gainMaitre() { return Math.pow(volume / 100, 1.6); }

  var GAINS = {
    effleure: 0.14, tap: 0.4, cran: 0.18, scan: 0.32, code: 0.34,
    glitch: 0.42, page: 0.5, ouvre: 0.5,
    balaye: 0.45, succes: 0.55, trait: 0.6, panier: 0.7, souffle: 0.7, lame: 0.85
  };

  // Le cran des roulettes peut tomber dix fois en trois secondes : relevé
  // « trop gros ». Son gain est le plus bas de la banque et il est ÉCOURTÉ —
  // l'attaque du tic, pas sa queue de résonance.
  var DUREES = { cran: 0.28, tap: 0.5, effleure: 0.4 };

  var tampons = {}, requetes = {};
  /* LA MUSIQUE EST UN ELEMENT <audio>, PAS UN TAMPON DECODE. Trois minutes
     et demie decodees en memoire pesaient ~70 Mo — un luxe de bureau, une
     brutalite de telephone. L'element diffuse en continu, le graphe ne
     recoit que son flux, et le fondu se fait sur le meme gain. */
  var elMusique = null, srcMusique = null, gainMusique = null, musique = false;
  /* LE DROIT D'ENTRER. Sur l'accueil, la musique attend la fin du
     monogramme : c'est la forge qui donne le signal (scene(p), p >= 0,82 —
     l'instant ou « NE POUR LE COMBAT » commence a s'ecrire). Ailleurs, pas
     de scene a respecter : elle entre des l'allumage. */
  var musiqueVoulue = false;

  /* LE VENT. Un lit de bruit filtre, SYNTHETISE (deux secondes de bruit
     blanc en boucle dans un passe-bande) : zero fichier, zero reseau. Il
     tient l'espace avant que la musique n'ait le droit d'entrer, et il
     repond au geste — chaque coup de molette le fait monter d'un souffle,
     en frequence et en niveau, puis il retombe. Une fois la musique lancee,
     il ne disparait pas : il passe dessous (base divisee par trois), pour
     que la piece garde son air. */
  var vent = null, gainVent = null, filtreVent = null, tVentBas = null;
  var VENT_BASE = 0.06, VENT_CRETE = 0.2;

  function souffleVent() {
    if (vent || !ctx) return;
    var sr = ctx.sampleRate, n = sr * 2;
    var b = ctx.createBuffer(1, n, sr);
    var d = b.getChannelData(0), lp = 0;
    for (var i = 0; i < n; i++) {
      lp = lp * 0.94 + (Math.random() * 2 - 1) * 0.06;
      d[i] = lp * 3.2;
    }
    vent = ctx.createBufferSource();
    vent.buffer = b;
    vent.loop = true;
    filtreVent = ctx.createBiquadFilter();
    filtreVent.type = 'bandpass';
    filtreVent.frequency.value = 480;
    filtreVent.Q.value = 0.7;
    gainVent = ctx.createGain();
    gainVent.gain.setValueAtTime(0.0001, ctx.currentTime);
    gainVent.gain.setTargetAtTime(VENT_BASE, ctx.currentTime, 0.8);
    vent.connect(filtreVent);
    filtreVent.connect(gainVent);
    gainVent.connect(maitre);
    vent.start();
  }

  function baseVent() { return musique ? VENT_BASE / 3 : VENT_BASE; }
  function creteVent() { return musique ? VENT_CRETE / 2.5 : VENT_CRETE; }

  // Le scroll fait un bruit : la rafale suit la vitesse de la molette puis
  // retombe vers la base en un quart de seconde. Pas de boucle rAF — deux
  // rampes d'AudioParam par evenement, c'est l'API qui lisse.
  var yPrec = 0, tPrec = 0;
  window.addEventListener('scroll', function () {
    if (!actif || !gainVent) return;
    var t = performance.now();
    var v = Math.abs(window.scrollY - yPrec) / Math.max(16, t - tPrec);
    yPrec = window.scrollY; tPrec = t;
    var force = Math.min(v / 3, 1);
    gainVent.gain.setTargetAtTime(baseVent() + (creteVent() - baseVent()) * force, ctx.currentTime, 0.08);
    filtreVent.frequency.setTargetAtTime(480 + force * 420, ctx.currentTime, 0.1);
    clearTimeout(tVentBas);
    tVentBas = setTimeout(function () {
      if (!gainVent) return;
      gainVent.gain.setTargetAtTime(baseVent(), ctx.currentTime, 0.25);
      filtreVent.frequency.setTargetAtTime(480, ctx.currentTime, 0.3);
    }, 240);
  }, { passive: true });

  function reveille() {
    if (ctx) { if (ctx.state === 'suspended' && ctx.resume) ctx.resume(); return ctx; }
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    try { ctx = new AC(); } catch (e) { return null; }

    maitre = ctx.createGain();
    maitre.gain.value = gainMaitre();

    // La musique tourne pendant qu'un verrou claque : sans compresseur, la
    // rencontre sature. Seuil bas, rapport doux — il rattrape, il n'écrase pas.
    var comp = ctx.createDynamicsCompressor();
    comp.threshold.value = -24;
    comp.knee.value = 18;
    comp.ratio.value = 3;
    comp.attack.value = 0.004;
    comp.release.value = 0.2;
    maitre.connect(comp);
    comp.connect(ctx.destination);
    return ctx;
  }

  /* Un fichier, une requête, pour toujours : la première demande télécharge
     et décode, les suivantes attendent le même tampon. decodeAudioData en
     forme rappel, pas promesse — Safari d'avant 14 ne connaît que celle-là. */
  function charge(nom, cb) {
    if (!CFG) return;
    if (tampons[nom]) { if (cb) cb(tampons[nom]); return; }
    if (requetes[nom]) { if (cb) requetes[nom].push(cb); return; }
    var url = nom === 'bgm' ? CFG.bgm : (CFG.fx && CFG.fx[nom]);
    if (!url) return;
    requetes[nom] = cb ? [cb] : [];
    fetch(url).then(function (r) { return r.arrayBuffer(); }).then(function (ab) {
      ctx.decodeAudioData(ab, function (buf) {
        tampons[nom] = buf;
        var attend = requetes[nom] || [];
        delete requetes[nom];
        for (var i = 0; i < attend.length; i++) attend[i](buf);
      }, function () { delete requetes[nom]; });
    }).catch(function () { delete requetes[nom]; });
  }

  var dernier = 0, dernierDe = {};
  function jouer(nom) {
    if (!actif || !GAINS[nom]) return;
    if (!reveille()) return;
    var t = performance.now();
    if (nom !== 'lame' && t - dernier < 45) return;
    if (dernierDe[nom] && t - dernierDe[nom] < 90) return;
    dernier = t; dernierDe[nom] = t;
    charge(nom, function (buf) {
      if (!actif) return;
      var src = ctx.createBufferSource();
      src.buffer = buf;
      var g = ctx.createGain();
      g.gain.value = GAINS[nom];
      src.connect(g);
      g.connect(maitre);
      var t0 = ctx.currentTime;
      src.start(t0);
      // Les gestes rapprochés ne jouent que leur attaque : la queue d'un tic
      // qui résonne encore quand le suivant tombe, c'est ça le « trop gros ».
      var d = DUREES[nom];
      if (d && buf.duration > d) {
        g.gain.setValueAtTime(GAINS[nom], t0 + d - 0.06);
        g.gain.setTargetAtTime(0.0001, t0 + d - 0.06, 0.02);
        src.stop(t0 + d + 0.1);
      }
    });
  }

  /* L'élément se prépare dès l'ALLUMAGE : le navigateur bufférise pendant
     toute la séquence du monogramme, sans jouer une note. Au signal, plus
     un octet à attendre. Relevé : « le thème commence trop lentement » —
     c'était le cumul du départ du flux au signal ET d'un fondu de 2,5 s. */
  function prepareMusique() {
    if (elMusique || !CFG || !CFG.bgm || !ctx) return;
    elMusique = new Audio(CFG.bgm);
    elMusique.loop = true;
    elMusique.crossOrigin = 'anonymous';
    elMusique.preload = 'auto';
    srcMusique = ctx.createMediaElementSource(elMusique);
    gainMusique = ctx.createGain();
    srcMusique.connect(gainMusique);
    gainMusique.connect(maitre);
  }

  /* L'ENTRÉE, PUIS LA CROISIÈRE. Le morceau entrait à son niveau de fond et
     passait inaperçu : « le début du thème doit être plus fort ». Il tombe
     donc à 0,55 en un demi-tour, tient sa mesure d'ouverture sept secondes,
     puis redescend seul à 0,32 sur une constante de 2,2 s — assez lente pour
     qu'on ne l'entende pas baisser, assez courte pour que les gestes
     reprennent le dessus avant le premier survol. */
  var MUS_ENTREE = 0.55, MUS_CROISIERE = 0.32, MUS_TENUE = 7;

  function lanceMusique() {
    if (!actif || musique || !CFG || !CFG.bgm) return;
    if (!reveille()) return;
    prepareMusique();
    var tm = ctx.currentTime;
    gainMusique.gain.setValueAtTime(0.0001, tm);
    gainMusique.gain.exponentialRampToValueAtTime(MUS_ENTREE, tm + 0.5);
    // Le palier est ancré avant la descente : sans ce point fixe,
    // setTargetAtTime partirait de la valeur courante de la rampe.
    gainMusique.gain.setValueAtTime(MUS_ENTREE, tm + MUS_TENUE);
    gainMusique.gain.setTargetAtTime(MUS_CROISIERE, tm + MUS_TENUE, 2.2);
    musique = true;
    var p = elMusique.play();
    // Refus du navigateur (onglet caché, geste manquant) : on rend le
    // drapeau, le prochain signal retentera.
    if (p && p.catch) p.catch(function () { musique = false; });
    if (gainVent) gainVent.gain.setTargetAtTime(baseVent(), ctx.currentTime, 1.4);
  }

  // Le signal de la forge : chaque frame du hero passe ici avec sa
  // progression. Quand la plaque commence à s'écrire, la musique entre.
  function scene(p) {
    if (!musiqueVoulue && p >= 0.82) { musiqueVoulue = true; lanceMusique(); }
  }

  /* ————— LA BANQUE ARRIVE EN TROIS VAGUES —————
     Elle partait d'un bloc : quatorze requêtes en parallèle, 618 Ko mesurés
     au réseau, déclenchées au premier défilement — c'est-à-dire pile au
     moment où le navigateur va chercher les images sous le pli. Sur un
     téléphone en 4G, six visiteurs sur dix ici, ce demi-méga passe devant
     les photos de la boutique.

     On les envoie donc dans l'ORDRE OÙ ELLES PEUVENT SONNER.

       vague 1, tout de suite ... 108 Ko  survol, clic, cran, balayage
       vague 2, au repos ....... 305 Ko  la séquence de la forge
       vague 3, plus tard ...... 205 Ko  panier, succès, navigation

     Rien n'est perdu si un son manque : `charge()` va le chercher à la
     demande et le joue dès qu'il est là. Les vagues ne sont donc pas une
     garantie, ce sont des paris — et ils sont classés par ce qui tombe en
     premier. Le souffle de la coulée, par exemple, demande d'avoir déjà
     défilé dans la forge : la vague 2 est là depuis longtemps.

     `requestIdleCallback` avec plafond : sur un fil occupé le repos peut ne
     jamais venir, le délai force alors la main. */
  var VAGUE_1 = ['effleure', 'tap', 'cran', 'balaye'];
  var VAGUE_2 = ['scan', 'code', 'glitch', 'souffle'];

  function auRepos(fn, plafond) {
    if (window.requestIdleCallback) requestIdleCallback(fn, { timeout: plafond });
    else setTimeout(fn, plafond);
  }

  function chargeListe(liste) {
    for (var i = 0; i < liste.length; i++) charge(liste[i]);
  }

  function precharge() {
    chargeListe(VAGUE_1);
    auRepos(function () {
      chargeListe(VAGUE_2);
      auRepos(function () {
        for (var n in GAINS) {
          if (!GAINS.hasOwnProperty(n)) continue;
          if (VAGUE_1.indexOf(n) > -1 || VAGUE_2.indexOf(n) > -1) continue;
          charge(n);
        }
      }, 2500);
    }, 900);
  }

  function ambiance(allume) {
    if (allume) {
      if (!reveille()) return;
      souffleVent();
      // Pas de forge sur cette page : rien à attendre, la musique entre.
      if (!document.querySelector('[data-vorog-hero]')) musiqueVoulue = true;
      if (musiqueVoulue) lanceMusique();
      else prepareMusique();
      precharge();
    } else {
      if (musique) {
        try {
          gainMusique.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.15);
          var m = elMusique;
          setTimeout(function () { try { m.pause(); } catch (e) {} }, 700);
        } catch (e) {}
        musique = false;
      }
      if (vent) {
        try {
          gainVent.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.2);
          var w = vent;
          setTimeout(function () { try { w.stop(); } catch (e) {} }, 900);
        } catch (e) {}
        vent = null; gainVent = null; filtreVent = null;
      }
    }
  }

  /* ————— LA VEILLE —————
     Trois façons de ne plus écouter : changer d'onglet, passer la fenêtre
     derrière une autre, ou ne plus rien faire du tout. Les trois mènent ici.

     On ne DÉMONTE rien — `ambiance(false)` arrête le vent pour de bon et
     oublie où en était le morceau. La veille se contente de fermer le
     robinet maître, de mettre l'élément audio en pause (plus un octet, plus
     un décodage) et de suspendre le contexte : le processeur retombe à zéro
     et tout redémarre exactement où on l'avait laissé. */
  var enVeille = false, coupee = false, tInactif = null, derniereActivite = 0;
  var INACTIF = 60000;

  /* L'ARRÊT FRANC. Tout ce qui coupe réellement le son est ici, et c'est
     SYNCHRONE — pas une promesse, pas un minuteur. */
  function coupeNet() {
    if (coupee) return;
    coupee = true;
    if (elMusique && musique) { try { elMusique.pause(); } catch (e) {} }
    if (ctx && ctx.suspend) { try { ctx.suspend(); } catch (e) {} }
  }

  /* DEUX MANIÈRES DE S'ENDORMIR, ET LA DIFFÉRENCE EST UN BUG CORRIGÉ.

     Version précédente : fondu, puis coupure dans un `setTimeout` de 700 ms
     — pour que l'arrêt ne s'entende pas. Ça marche tant que la page tourne.
     Sur téléphone, quand on verrouille l'écran ou qu'on passe à une autre
     application, le navigateur GÈLE le JavaScript : le minuteur ne part
     jamais, l'élément audio n'est jamais mis en pause, et la musique
     continue dans la poche. C'est exactement ce qui a été rapporté.

     Désormais :
       • page cachée (verrouillage, changement d'application, onglet quitté)
         → `immediat` : on coupe DANS le gestionnaire, avant le gel.
       • fenêtre passée derrière, ou plus un geste depuis une minute, page
         toujours visible → le fondu tranquille d'avant.

     Le drapeau `coupee` est séparé de `enVeille` pour une raison précise :
     sur mobile, `blur` arrive AVANT `visibilitychange`. Le premier endort
     en douceur, le second doit pouvoir couper net juste après — avec un
     seul drapeau, le second appel serait sorti en début de fonction et
     n'aurait rien coupé du tout. */
  function veille(dors, immediat) {
    if (!actif) return;
    if (dors) {
      if (!enVeille) {
        enVeille = true;
        if (ctx && maitre) maitre.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.25);
        if (!immediat) setTimeout(function () { if (enVeille) coupeNet(); }, 700);
      }
      if (immediat) {
        if (ctx && maitre) {
          try { maitre.gain.cancelScheduledValues(ctx.currentTime); } catch (e) {}
          maitre.gain.value = 0.0001;
        }
        coupeNet();
      }
    } else {
      if (!enVeille) return;
      enVeille = false;
      coupee = false;
      if (!ctx || !maitre) return;
      if (ctx.state === 'suspended' && ctx.resume) ctx.resume();
      if (elMusique && musique) {
        var p = elMusique.play();
        if (p && p.catch) p.catch(function () {});
      }
      maitre.gain.setTargetAtTime(gainMaitre(), ctx.currentTime, 0.25);
    }
  }

  function dors() { veille(true, false); }

  /* Un geste, quel qu'il soit, remet le compteur à zéro. Le réveil est
     immédiat ; le RÉARMEMENT du minuteur, lui, est limité à une fois par
     seconde — `pointermove` tombe cent fois par seconde et n'a pas besoin
     de cent minuteurs. */
  function activite() {
    if (!actif) return;
    if (enVeille) { veille(false); derniereActivite = 0; }
    var t = performance.now();
    if (t - derniereActivite < 1000) return;
    derniereActivite = t;
    clearTimeout(tInactif);
    tInactif = setTimeout(dors, INACTIF);
  }

  var GESTES = ['pointermove', 'pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'];
  for (var gi = 0; gi < GESTES.length; gi++) {
    document.addEventListener(GESTES[gi], activite, { passive: true, capture: true });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') veille(true, true);
    else activite();
  });

  /* `pagehide` en plus de `visibilitychange` : c'est lui qui part quand la
     page entre en cache arrière ou que l'onglet est quitté, et sur iOS il
     est le plus fiable des deux au moment où l'application passe derrière.
     Les deux mènent au même arrêt franc — appeler deux fois ne coûte rien,
     `coupeNet()` est idempotent. */
  window.addEventListener('pagehide', function () { veille(true, true); });

  window.addEventListener('blur', function () {
    // Le focus qui part dans une iframe DE LA PAGE — le chat, le module
    // d'avis — n'est pas un départ : le visiteur est toujours devant.
    var a = document.activeElement;
    if (a && a.tagName === 'IFRAME') return;
    // La page reste visible : on a le temps de faire ça proprement.
    veille(true, false);
  });

  window.addEventListener('focus', activite);
  window.addEventListener('pageshow', activite);

  function regleVolume(v, garde) {
    if (isNaN(v)) return;
    volume = Math.max(0, Math.min(100, v));
    if (garde) { try { localStorage.setItem(CLEV, String(volume)); } catch (e) {} }
    // En veille, le robinet maître est fermé : y réécrire le volume
    // rallumerait le son dans un onglet que personne ne regarde.
    if (maitre && !enVeille) maitre.gain.setTargetAtTime(gainMaitre(), ctx.currentTime, 0.05);
    var c = document.querySelectorAll('[data-vorog-volume]');
    for (var i = 0; i < c.length; i++) if (c[i].value !== String(volume)) c[i].value = volume;
  }

  function marque() {
    var b = document.querySelectorAll('[data-vorog-son]');
    for (var i = 0; i < b.length; i++) b[i].setAttribute('aria-pressed', actif ? 'true' : 'false');
    document.documentElement.classList.toggle('vk-son-on', actif);
    regleVolume(volume, false);
  }

  document.addEventListener('input', function (e) {
    var c = e.target;
    if (!c || !c.hasAttribute || !c.hasAttribute('data-vorog-volume')) return;
    regleVolume(parseInt(c.value, 10), true);
  });

  function bascule() {
    actif = !actif;
    try { localStorage.setItem(CLE, actif ? '1' : '0'); } catch (e) {}
    marque();
    // Allumer sans rien entendre laisse croire que ça n'a pas marché : le
    // verrou répond tout de suite, le beat s'installe derrière.
    if (actif) {
      enVeille = false; coupee = false;
      reveille(); jouer('lame'); ambiance(true);
      activite();
    } else {
      // Éteindre, c'est sortir de la veille aussi : sinon le prochain
      // allumage repartirait avec le robinet maître déjà fermé. Et les DEUX
      // drapeaux se lèvent, sans quoi `coupeNet()` croirait avoir déjà
      // coupé et ne couperait plus jamais.
      clearTimeout(tInactif);
      enVeille = false; coupee = false;
      ambiance(false);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var b = t && t.closest ? t.closest('[data-vorog-son]') : null;
    if (!b) return;
    e.preventDefault();
    bascule();
  });

  // Le geste, pas l'élément : on sonne quand le doigt touche, pas quand la
  // page a fini de réagir — c'est ce décalage qui fait le son en retard.
  var CIBLES = 'a[href], button, summary, [role="button"], .vorog-avis__tout, label[for]';

  document.addEventListener('pointerdown', function (e) {
    if (!actif) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-vorog-son]')) return;
    if (t.closest(CIBLES)) jouer('tap');
  }, { passive: true });

  // Le survol ne sonne qu'au CHANGEMENT de cible : sans ça, traverser une
  // barre de navigation ferait crépiter le même lien vingt fois.
  var survole = null;
  document.addEventListener('pointerover', function (e) {
    if (!actif) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var c = t.closest(CIBLES);
    if (c === survole) return;
    survole = c;
    if (c) jouer('effleure');
  }, { passive: true });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) jouer('panier');
  }, true);

  /* ALLUMER SANS BASCULER. L'écran d'entrée a besoin d'ouvrir l'atelier
     depuis SON clic — c'est la seule fenêtre où le navigateur accepte de
     démarrer l'audio. `bascule()` ne convient pas : le son étant allumé
     d'origine, elle l'aurait ÉTEINT. D'où cette porte à sens unique, qui ne
     touche jamais au choix de l'utilisateur. */
  function allume() {
    if (!actif) return;
    enVeille = false; coupee = false;
    ambiance(true);
    activite();
  }

  window.VorogSon = {
    jouer: jouer,
    scene: scene,
    allume: allume,
    bascule: bascule,
    actif: function () { return actif; },
    volume: function (v) { if (v === undefined) return volume; regleVolume(v, true); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', marque);
  else marque();

  /* L'ALLUMAGE NE DOIT PAS DEMANDER DE CLIC. Devoir appuyer sur le bouton
     pour lancer le thème casse l'entrée : on arrive, on fait défiler, ça doit
     sonner. On n'attend donc plus le seul `pointerdown`.

     CE QUE LE NAVIGATEUR AUTORISE, EXACTEMENT. Un contexte audio ne démarre
     qu'après une « activation utilisateur », et la liste des événements qui
     la donnent est fixée par le navigateur, pas par nous : clic, touche
     clavier, et `touchend`. Le défilement à la molette ou au pavé tactile
     n'en fait PAS partie.

     Sur téléphone — six visiteurs sur dix ici — un défilement se termine
     toujours par un `touchend` : faire défiler allume donc réellement le son,
     sans rien toucher d'autre. Sur ordinateur à la molette, le contexte reste
     suspendu jusqu'au premier clic ou à la première touche ; c'est une règle
     du navigateur, pas un choix de conception, et aucune bibliothèque ne la
     contourne.

     D'où la forme : on tente à CHAQUE geste, et on garde l'oreille ouverte
     tant que le contexte n'est pas RÉELLEMENT parti (`state === 'running'`).
     Le jour où l'activation arrive — un clic sur n'importe quel lien —
     l'atelier s'ouvre sans que personne n'ait rien demandé. Le garde de
     200 ms existe parce que `scroll` tombe soixante fois par seconde et que
     chaque tentative touche une vingtaine de fonctions. */
  if (actif) {
    /* MESURÉ, PAS SUPPOSÉ : une VRAIE molette (événement de confiance, la
       page a bien défilé) laisse `navigator.userActivation.hasBeenActive` à
       `false`. Le défilement à la molette ne donne aucune activation, et
       aucune bibliothèque ne contourne ça. On ratisse donc TOUS les
       événements qui, eux, en donnent — un seul suffit, et le premier qui
       passe ouvre l'atelier. `wheel` reste dans la liste : il n'active rien
       mais il PRÉPARE (banque chargée, morceau bufferisé), pour que
       l'activation suivante ne coûte pas une seconde d'attente. */
    var EVEIL = ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click',
                 'keydown', 'touchstart', 'touchend', 'wheel'];
    var dernierEveil = 0;

    var oteEveil = function () {
      for (var oi = 0; oi < EVEIL.length; oi++) {
        document.removeEventListener(EVEIL[oi], tenteEveil, true);
      }
      window.removeEventListener('scroll', eveilAuDefilement);
    };

    /* PIÈGE ÉVITÉ DE JUSTESSE, ET RELEVÉ À L'ÉCRAN. La première version
       sortait d'entrée si le contexte tournait déjà : « il tourne, donc
       c'est allumé ». Faux. Un simple survol de lien appelle `jouer()`, qui
       crée le contexte pour un bruit de 40 ms — le contexte tourne, mais ni
       le vent, ni la musique, ni la banque n'ont démarré. Le défilement
       lâchait alors l'écoute sans jamais appeler `ambiance()`, et le son
       restait muet en se croyant allumé.

       L'ordre est donc : on appelle TOUJOURS `ambiance()` d'abord, et on ne
       relâche l'écoute qu'après, une fois le contexte réellement en marche.
       `ambiance()` est idempotente — vent déjà soufflé, tampons déjà
       chargés, musique déjà lancée sortent tous en début de fonction. */
    var tenteEveil = function () {
      if (!actif) { oteEveil(); return; }
      if (document.visibilityState !== 'visible') return;
      var te = performance.now();
      if (te - dernierEveil < 200) return;
      dernierEveil = te;
      ambiance(true);
      activite();
      if (ctx && ctx.state === 'running') oteEveil();
    };

    /* LE DÉFILEMENT S'ÉCOUTE SUR `window`, ET SEULEMENT S'IL A VRAIMENT LIEU.
       Première version : `scroll` sur `document` en capture. Relevé au réseau,
       les 3,7 Mo de la banque partaient DÈS LE CHARGEMENT, avant que le
       visiteur n'ait touché à quoi que ce soit — parce qu'en phase de capture
       le document voit AUSSI le défilement des éléments internes, et qu'un
       carrousel ou un tiroir qui s'initialise en émet. Facturer quatre méga
       à quelqu'un qui vient d'arriver et n'a rien demandé, c'est exactement
       ce qu'on ne veut pas.

       `window` ne reçoit que le défilement de la page elle-même, et le seuil
       de 4 px écarte les faux départs à position zéro. */
    var eveilAuDefilement = function () {
      if (window.scrollY > 4) tenteEveil();
    };

    for (var ei = 0; ei < EVEIL.length; ei++) {
      document.addEventListener(EVEIL[ei], tenteEveil, { passive: true, capture: true });
    }
    window.addEventListener('scroll', eveilAuDefilement, { passive: true });
  }
})();
